import React from 'react';
import styles from '../styles.module.css';

export default function LiveDot({ className = '' }: { className?: string }) {
  return <span className={`${styles.badgeDot} ${className}`} />;
}
